import styled, { css } from 'styled-components';

import { ReactComponent as WarningIcon } from '../../assets/images/blueTheme/alertTriangle.svg';
import { BlueButton } from '../../components/BlueTheme';

export const NotFoundPageOuterContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

export const NotFoundPageInnerContainer = styled.div`
  flex-grow: 1;
  width: 100%;
  background: ${({ theme }): string => theme.admanColors!.gray.light.fg[6]};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContentContainer = styled.div`
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NotFoundPageTitle = styled.div(
  ({ theme: { spacers } }) => css`
    text-align: center;
    font-family: MultiplaneTWDC;
    font-weight: 600;
    font-size: 36px;
    line-height: 42px;
    margin-top: ${spacers!.spacer05};
  `
);

export const NotFoundPageSubTitle = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    display: inline-block;
    font-family: InspireTWDC;
    margin: ${spacers!.spacer04} 0;
    text-align: center;
    color: ${admanColors!.gray.light.bg3[3]};
    font-size: 18px;
    line-height: 21px;
  `
);

export const GoToHomeButton = styled(BlueButton)`
  height: ${({ theme }): string => theme.spacers!.spacer06};
`;

export const NotFoundIcon = styled(WarningIcon)(
  ({ theme: { admanColors } }) => css`
    width: 50px;
    height: 50px;

    path {
      fill: ${admanColors!.gray.light.bg3[3]};
    }
  `
);
